var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import ButtonBase from './Button.base';
var DefaultButton = React.forwardRef(function (props, ref) { return React.createElement(ButtonBase, __assign({}, props, { ref: ref })); });
DefaultButton.defaultProps = {
    buttonType: 'button',
    disabled: false,
    dropdown: false,
    fullWidth: false,
    selected: false,
    size: 'medium',
    __flexed: false,
    __TYPE: 'DefaultButton',
};
export default DefaultButton;
